import React from 'react'
import useFlow from '../../hooks/useFlow'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import styles from './styles.module.css'
import BaseForm from "../base-form/base-form"
import Button from '../nura/button/button'
import Logo from '../logo/logo'

const steps = [
    {
        title: 'Welcome to Nura Flow',
        description: 'Where you can build workflows designed for automating your content creation process',
        Component: () => <Logo cursor='auto' />
    },
    {
        title: 'Blueprint',
        description: 'To begin, you can create a project, which will navigate to the projects blueprint page',
        Component: () => <img src="https://flow.nuraml.com/other/blueprint_tutorial.gif" />,
    },
    {
        title: 'Nodes',
        description: 'Every blueprint is comprised of a collection of nodes. Each node performs some task within the workflow',
        Component: () => <img src="https://flow.nuraml.com/other/nodes_tutorial.gif" />,
    },
    {
        title: 'Search',
        description: 'You can search for nodes by either double clicking anywhere on the canvas or using the search box in the top right of the screen',
        Component: () => <img src="https://flow.nuraml.com/other/search_tutorial.gif" />,
    },
    {
        title: 'Change title',
        description: 'You may also rename nodes by single clicking on the header of that node',
        Component: () => <img src="https://flow.nuraml.com/other/edit-node_tutorial.gif" />,
    },
    {
        title: 'Delete',
        description: 'Nodes and edges between nodes can be deleted by the use of the backspace key on your keyboard',
        Component: () => <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '200px', backgroundColor: `var(--background-secondary)` }}>
            Click on node or edge then press backspace to delete
        </div>,
    },
    {
        title: 'Run',
        description: 'When your ideal blueprint is created, you can run it by pressing the run button at the bottom left of your screen',
        Component: () => <img src="https://flow.nuraml.com/other/run_tutorial.gif" />,
    },
    {
        title: 'Feedback',
        description: 'Our dev team is small, and this software is in an early stage. Feedback is always appreciated!',
        Component: () => <img src="https://flow.nuraml.com/other/submit_feedback.gif" />,
    },
]

const TutorialForm = ({ onBack, onSubmit }) => {
    const flow = useFlow({ onBack, onSubmit })

    const currentStep = steps[flow.step]
    const CurrentStepComponent = steps[flow.step]?.Component || (() => null)

    const handleNext = () => {
        if (flow.step + 1 > steps?.length - 1) {
            onSubmit()
            return
        }
        flow.incrementStep()
    }

    return (
        <Card variant="modal" style={{ maxWidth: 500, height: 'auto' }}>
            <BaseForm onBack={flow.handleBack} title={currentStep?.title}>
                <div style={{ marginTop: 25 }}>{currentStep?.description}</div>

                <div className={styles.contentContainer}>
                    <CurrentStepComponent />                    
                </div>

                {
                    (flow.step + 1 > steps?.length - 1) ? (
                        <Button variant="primary" onClick={handleNext}>Finish</Button>
                    ) : (
                        <Button variant="outline" onClick={handleNext}>Next</Button>
                    )
                }

            </BaseForm>
        </Card>
    )
}

export default ({ onClose, show }) => show ? (
    <Modal show={show} style={{ minWidth: 358, height: 'auto', maxWidth: 800 }} onClose={onClose}>
        <TutorialForm onBack={onClose} onSubmit={onClose} />
    </Modal>
) : null
